export const isSameVideoReference = (a, b) =>
  !!a &&
  !!b &&
  ['matchId', 'period', 'sport', 'track', 'version'].every(
    (key) => a[key] === b[key],
  );

export const filterEventsWithNoVideoReference = (events) =>
  events?.filter((event) => {
    if (!event || typeof event !== 'object' || Array.isArray(event))
      return false;

    const hasOwn = (key) => Object.prototype.hasOwnProperty.call(event, key);
    const hasCoreKeys = ['matchId', 'sport', 'track', 'version'].every(hasOwn);
    const hasPeriodOrMatchPart = hasOwn('period') || hasOwn('matchPart');

    return hasCoreKeys && hasPeriodOrMatchPart;
  });
